import { s as o } from "../../../chunk-GSYRQO2U-911f8fc9.js";
import { createMultiStyleConfigHelpers as i } from "@chakra-ui/react";
const { definePartsStyle: l, defineMultiStyleConfig: e } = i(
  o.keys
), r = l(({ colorScheme: t }) => ({
  container: {
    width: "100%"
  },
  thumb: {
    boxSize: 3.5,
    backgroundColor: `${t}.500`,
    borderRadius: "full",
    top: 0,
    _active: {
      outlineWidth: "3px",
      outlineStyle: "solid",
      outlineColor: `${t}.100`,
      outlineOffset: 0,
      backgroundColor: `${t}.600`
    },
    _hover: {
      outlineWidth: "3px",
      outlineStyle: "solid",
      outlineColor: `${t}.100`,
      outlineOffset: 0,
      backgroundColor: `${t}.500`
    },
    _focusVisible: {
      outlineWidth: "3px",
      outlineStyle: "solid",
      outlineColor: `${t}.100`,
      outlineOffset: 0,
      backgroundColor: `${t}.500`
    }
  },
  track: {
    height: 1,
    backgroundColor: `${t}.50`,
    borderRadius: "full"
  },
  filledTrack: {
    height: 1,
    backgroundColor: `${t}.400`,
    borderRadius: "full"
  },
  mark: {
    marginTop: -9,
    marginLeft: -2.5,
    width: "100%",
    color: "primary.500",
    fontSize: "0.875rem",
    lineHeight: 1,
    _first: {
      paddingLeft: 2
    }
  }
})), u = e({
  baseStyle: r,
  defaultProps: {
    colorScheme: "secondary"
  }
});
export {
  u as Slider
};
//# sourceMappingURL=Slider.es.js.map
